export default {
  label: "App Store",
  tabs: {
    softwareReview: {
      label: "Software Review",
      noSoftwareToReview: "Keine Software zur Überprüfung",
      noSoftwareToReviewHelperText:
        "Software, die noch überprüft werden muss, erscheint hier, sobald sie über das Terminal hochgeladen wurde.",
    },
    myEdgeDevices: {
      label: "Meine Edge Devices",
      lastConnection: "Last Connection",
      updateStatus: "Update Status",
      sshSession: "SSH Session",
      appSetSubscriptions: "App Set Subscriptions ",
      activities: "Aktivitäten",
      appSetsToApps: {
        addButton: "Appset Hinzufügen",
        removeButton: "Appset Entfernen",
      },
      myEdgeDeviceDetails: "Meine Edge Device Details",
    },
    newReleases: {
      label: "Software Review",
      newVersion: "Neue Version",
      appSet: "New Releases",
      softwareToReview: "Apps Pending Review",
      deniedSoftware: "Denied Reviews",
      newAppset: "Neues App Set",
      apps: "Apps",
      app: "App",
      goBack: "Zurück zu Software Review",
      appCategory: "App Category",
      appsOfSelectedSnapsets: {
        column: {
          version: "Version",
          revision: "Revision",
          releaseDate: "Datum der Veröffentlichung",
        },
      },
      removeApps: {
        message:
          "Dieses App-Set ist derzeit einigen Ihrer Geräte zugewiesen. Das Entfernen ausgewählter Anwendungen hat direkte Auswirkungen auf diese Geräte. Entfernen Sie sie trotzdem?",
        title: "Anwendung(en) entfernen",
      },
      deviceList: "Device Liste",
      activities: "Aktivitäten",
      appCategories: "App Kategorien",
      developer: "Entwickler",
      version: "Version",
      revision: "Revision",
      releaseDate: "Release Date",
      size: "Size[MB]",
      pushedSince: "Gepusht seit",
      firstRelease: "Erstveröffentlichung",
      currentlyInstalledOn: "Derzeit installiert auf",
    },

    softwarePackages: {
      label: "Software-Pakete",
      noSoftwareYet: (category: string) => `Noch keine ${category} Software`,
      noSoftwareHelperText: "Software, die über das Terminal hochgeladen wurde, wird hier angezeigt.",
    },
    apps: {
      label: "Apps",
      addButton: "App Hinzufügen",
      editAppDescription: "App Beschreibung bearbeiten",
      shareToAllTenants: "Für alle Mandanten freigeben",
      sharedToAllTenants: "Für alle Mandanten freigegeben",
      notShared: "Nicht freigegeben",
      sharedByMLPA: "Von MLPA geteilt",
      removeButton: "App Entfernen",
      developerLabel: "Entwickler",
      noAppsCreatedYet: "Fügen Sie Ihre erste App hinzu",
      noAppsCreatedHelperText:
        "Apps müssen über das Terminal hochgeladen und dann im Abschnitt 'Software zur Überprüfung' genehmigt werden.",
      appsOverview: {
        currentlyInstalledOn: "Derzeit installiert auf",
        noAppVersionsMessage: "Noch keine Versionen dieser App veröffentlicht",
        columns: {
          versionEvaluation: "Versionsbewertung",
          version: "Version",
          releaseDate: "Erscheinungsdatum",
          status: "Status",
          usage: "Verwendung",
          category: "Kategorie",
          latestRevision: "Letzte Revision",
          addToAppset: "App set Zuordnung",
          detailPanel: {
            columns: { revision: "Revision", releaseDate: "Datum der Veröffentlichung", snapSets: "App sets" },
            dataList: {
              developerInfo: "Entwickler-Infos",
              developer: "Entwickler",
              releaseDate: "Datum der Veröffentlichung",
            },
          },
        },
      },
      usageOverview: {
        label: "Nutzungsübersicht",
        installedOn: "Installiert auf",
      },
      updatesOverview: {
        label: "Upadates Overview",
      },
      statusUpdate: {
        changeRatingTitle: "Bewertung für Version ändern",
        changeRatingLabel: "Bewertung ändern",
        changeVersionEvaluation: "Versionsbewertung ändern",
      },
    },
    updatePropositions: {
      label: "Update Propositions",
    },
  },
};
